/* Native details navigation: no app dependency; Escape and outside-click close it. */
(() => {
  if (window.ssHeaderMenusInstalled) return;
  window.ssHeaderMenusInstalled = true;
  const worlds = ['snackshark', 'halloween', 'sparhelden'];
  const refreshHeaders = () => {
    document.querySelectorAll('.ss3-header-v2').forEach((header) => {
      let world = header.dataset.ssPageWorld;
      if (!worlds.includes(world)) {
        try { world = window.sessionStorage.getItem('ss:last-world'); } catch (_) { world = null; }
      }
      if (!worlds.includes(world)) world = 'snackshark';
      header.dataset.ssHeaderWorld = world;
      header.querySelectorAll('[data-ss-menu-world]').forEach(menu => { menu.hidden = menu.dataset.ssMenuWorld !== world; });
      header.querySelectorAll('[data-ss-logo-world]').forEach(logo => { logo.hidden = logo.dataset.ssLogoWorld !== world; });
      header.querySelectorAll('details[open]').forEach(menu => menu.removeAttribute('open'));
    });
  };
  const closeMenus = (event) => {
    if (event.type === 'keydown' && event.key !== 'Escape') return;
    const menus = [...document.querySelectorAll('.ss3-header .ss3-mobile-menu[open], .ss3-header .ss3-menu-group[open]')];
    const focusMenu = menus.find(menu => menu.classList.contains('ss3-mobile-menu')) || menus.find(menu => menu.contains(document.activeElement));
    menus.forEach((menu) => {
      if (event.type === 'click' && menu.contains(event.target)) return;
      menu.removeAttribute('open');
    });
    if (event.type === 'keydown') focusMenu?.querySelector('summary')?.focus();
  };
  document.addEventListener('click', closeMenus);
  document.addEventListener('keydown', closeMenus);
  document.addEventListener('shopify:section:load', refreshHeaders);
  window.addEventListener('pageshow', refreshHeaders);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshHeaders, { once: true });
  else refreshHeaders();
})();
